import { useState, useEffect } from 'react';
import { globalGetService } from '../../../globalServices';
import { checkApiStatus } from '../../utils_v2';

const assetInfoCache = new Map();

const useAssetInfo = (type, slug) => {
    const cacheKey = `${type}-${slug}`;
    const cached = assetInfoCache.get(cacheKey);
    const [assetInfoData, setAssetInfoData] = useState(cached || {});
    const [assetSkeletonLoader, setAssetSkeletonLoader] = useState(!cached);

    useEffect(() => {
        if (assetInfoCache.has(cacheKey)) {
            setAssetInfoData(assetInfoCache.get(cacheKey));
            setAssetSkeletonLoader(false);
            return;
        } else{
            setAssetSkeletonLoader(true);
            globalGetService(`console/v2/asset/${type}/${slug}/asset_details/`)
            .then(response => {
                if (checkApiStatus(response)) {
                    assetInfoCache.set(cacheKey, response.data.data);
                    setAssetInfoData(response.data.data);
                }
                setAssetSkeletonLoader(false);
            });
        }
    }, [cacheKey]);

    const refreshAssetInfo = () => {
        assetInfoCache.delete(cacheKey);
        globalGetService(`console/v2/asset/${type}/${slug}/asset_details/`)
            .then(response => {
                if (checkApiStatus(response)) {
                    assetInfoCache.set(cacheKey, response.data.data);
                    setAssetInfoData(response.data.data);
                }
            });
    };

    return { assetInfoData, assetSkeletonLoader, refreshAssetInfo };
};

export default useAssetInfo;
